// extracted by mini-css-extract-plugin
export default {"link":"ImportedToolbar-module__link--MH9Y5"};